import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../lib/api';

interface RunEvent {
  id: number;
  ts: string;
  kind: string;
  payload: unknown;
}

export function RunAudit() {
  const { id } = useParams<{ id: string }>();
  const [events, setEvents] = useState<RunEvent[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    api
      .get<RunEvent[]>(`/api/runs/${id}/audit`)
      .then(setEvents)
      .catch((err) => setError((err as Error).message))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="flex-col">
      <div className="toolbar">
        <h1 style={{ margin: 0 }}>Audit log</h1>
        <span className="spacer" />
        <Link className="btn btn-ghost" to={`/runs/${id}/phase/7`}>
          Back to TEXEC execution
        </Link>
      </div>

      {loading && <p className="muted">Loading...</p>}
      {error && <p style={{ color: 'var(--bad)' }}>{error}</p>}

      <div className="card">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--border)' }}>
              <th style={{ padding: '6px 8px' }}>Time</th>
              <th style={{ padding: '6px 8px' }}>Kind</th>
              <th style={{ padding: '6px 8px' }}>Payload</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.id} style={{ borderBottom: '1px solid #1f242b' }}>
                <td className="mono small muted" style={{ padding: '6px 8px' }}>
                  {event.ts}
                </td>
                <td className="mono small" style={{ padding: '6px 8px' }}>
                  {event.kind}
                </td>
                <td style={{ padding: '6px 8px', maxWidth: 600 }}>
                  <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {event.payload ? JSON.stringify(event.payload, null, 2) : ''}
                  </pre>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
